





























































































































































































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import {debounce} from '@/utils';
import {gsap, ScrollTrigger} from '@/utils/gsap';
import {TranslateResult} from 'vue-i18n';
import {AccordionGroup} from '@/components/accordion';
import checkIE from '@/utils/ie';

import TranslatedRouter from '@/mixins/TranslatedRouter';
import ScrollTo from '@/mixins/ScrollTo';

@Component({
	components: {
		'v-accordion-group': AccordionGroup
	}
})
export default class CarouselWrapper extends Mixins(TranslatedRouter, ScrollTo) {
	@Prop({required: true}) readonly data: TranslateResult;
	sw: any = [];
	tl: any;
	currentSlide: number = 0;
	anim: boolean = false;
	tlArr: any[] = [];

	ease: string = 'elastic.out(1, 0.3)';
	easeInOut: string = 'back.inOut(1.7)';
	animationsInited: boolean = false;
	isMobile: boolean = false;

	$refs: {
		phone: HTMLElement

		carousel: HTMLElement
		carouselContentHead: HTMLElement[]
		carouselContentImage: HTMLElement[]
		carouselBenefits: HTMLElement[]
		sticky: HTMLElement
		background: HTMLElement
		animationWrapper: HTMLElement
		content: HTMLElement[]
		contentTrigger: HTMLElement[]

		carouselSlide1: HTMLElement
		carouselSlide2: HTMLElement
		carouselSlide3: HTMLElement

		carouselSlideImage: HTMLElement[]
	}

	get contentData(): any {
		return this.data;
	}

	get contentDataScreens(): any {
		return this.contentData.screens;
	}

	get cards(): any {
		return this.$t('footer.product.cards');
	}

	get screens(): any {

		if (!this.contentData.screens) {
			return;
		}
		return Object.keys(this.contentData.screens);
	}

	get isIE(): boolean {
		return checkIE();
	}

	@Watch('currentSlide')
	async onCurrentSlideChanged(newValue: number, oldValue: number): Promise<void> {
		if (newValue !== oldValue) {
			if (window.innerWidth > 767) {
				await this.$store.dispatch('updateAnimationCardsName', {
					key: this.contentData.cards[0],
					state: ['']
				});
			} else {
				await this.$store.dispatch('updateAnimationCardsName', {
					key: this.contentData.cards[newValue],
					state: ['']
				});
			}
		}

		if (window.innerWidth > 767) {
			await this.tlArr[oldValue].out.seek(0).play();
			await this.tlArr[newValue].in.seek(0).play();
		}
	}

	getImage(index: any, value: any): any {
		switch (index) {
			case 0:
				return {
					default: process.env.ASSET_BASE + require(`@/images/pattern/${value}.jpg`),
					retina: process.env.ASSET_BASE + require(`@/images/pattern/${value}@2.jpg`)
				}
			case 1:
				return {
					default: process.env.ASSET_BASE + require(`@/images/${value}`),
					retina: process.env.ASSET_BASE + require(`@/images/${value}`),
				}
			case 2:
				return {
					default: process.env.ASSET_BASE + require(`@/images/${value}`),
					retina: process.env.ASSET_BASE + require(`@/images/${value}`),
				}

		}

	}

	mounted(): void {
		if (typeof window === 'undefined') {
			return;
		}

		this.resizeHandler();

		window.addEventListener('resize', debounce(this.resizeHandler.bind(this), 100));
		window.addEventListener('orientationchange', this.resizeHandler.bind(this));

		this.$root.$on('canScrollToTop', (data: any) => {
			let element = this.$refs.carousel.querySelector(`.carousel__content--${data.name}`);

			if (!element) {
				return;
			}
			this.scrollToSection(element);
		});

	}

	initAnimations(): void {
		this.screens.forEach((screen: string, screenIndex: number) => {
			this.tlArr.push({
				in: gsap.timeline({paused: true})
					.fromTo(this.$refs.carouselSlideImage[screenIndex],
						{
							duration: 0.4,
							xPercent: 100,
							ease: 'none'
						},
						{
							xPercent: 0,
							duration: 0.2,
							autoAlpha: 1,
						}
					),
				out: gsap.timeline({paused: true})
					.to(this.$refs.carouselSlideImage[screenIndex],
						{
							xPercent: -100,
							duration: 0.2,
						}
					)
			});
		});
	}

	initScrollTrigger(): void {
		if (!this.$refs.contentTrigger) {
			return;
		}

		this.$refs.contentTrigger.forEach((element: HTMLElement) => {
			let sw = ScrollTrigger.create({
				trigger: element,
				onUpdate: (self: any) => {
					this.currentSlide = this.$refs.contentTrigger.indexOf(self.trigger);
				}
			})
			this.sw.push(sw);
		});
	}

	initCarouselContentImage(): void {
		let scrollTriggerInstances: any[] = [];
		Array.prototype.forEach.call(this.$refs.carouselContentImage, (image: HTMLElement, imageIndex: number) => {
			let benefitWrappers = this.$refs.carouselBenefits[imageIndex].querySelectorAll('.carousel__benefit');
			let cardsIncluded = this.contentDataScreens[this.screens[imageIndex]].items;

			let offset = image.getBoundingClientRect().height;

			Array.prototype.forEach.call(benefitWrappers, (benefit: Element, benefitIndex: number) => {

				let cards = cardsIncluded[benefitIndex].cards;

				let swBenefit = ScrollTrigger.create({
					trigger: benefit,
					start: () => `top +=${offset}px`,
					end: () => `bottom +=${offset + benefit.getBoundingClientRect().height}px`,
					onEnter: () => {
						this.$store.dispatch('updateAnimationCardsName', {
							key: this.contentData.cards[imageIndex],
							state: cards
						});
					},
					onEnterBack: () => {
						this.$store.dispatch('updateAnimationCardsName', {
							key: this.contentData.cards[imageIndex],
							state: cards
						});
					},
					onLeaveBack: () => {
						this.$store.dispatch('updateAnimationCardsName', {
							key: this.contentData.cards[imageIndex],
							state: cards
						});
					}
				});

				scrollTriggerInstances.push(swBenefit);
			});

		});

		scrollTriggerInstances.forEach((instance: any) => {
			this.sw.push(instance);
		})

	}

	stickyBackground(): void {
		if (!this.$refs.background) {
			return;
		}
		let sw = ScrollTrigger.create({
			trigger: this.$refs.carousel,
			start: 'top top',
			end: 'bottom bottom',
			pin: this.$refs.background,
			pinSpacing: false,
			scrub: 1.5
		});

		this.sw.push(sw);
	}

	async resizeHandler(): Promise<void> {

		this.isMobile = window.innerWidth < 768;

		await this.initScrollTrigger();

		if (window.innerWidth > 767 && !this.animationsInited) {

			await this.initAnimations();

			await this.tlArr[0].in.play();

			if (this.isIE) {
				await this.stickyBackground();
				await this.stickyScroll();
			}

			this.animationsInited = true;
		} else {
			this.initCarouselContentImage();
		}
	}

	stickyScroll(): void {
		if (!this.$refs.sticky) {
			return;
		}

		let sw = ScrollTrigger.create({
			trigger: this.$refs.sticky,
			start: 'top top',
			end: 'bottom bottom',
			pin: true,
			pinSpacing: false
		});

		this.sw.push(sw);
	}

	beforeDestroy() {

		window.removeEventListener('resize', this.resizeHandler.bind(this));
		window.removeEventListener('orientationchange', this.resizeHandler.bind(this));

		if (this.sw.length === null || typeof this.sw === 'undefined') {
			return;
		}
		this.sw.forEach((scrollTrigger: any) => scrollTrigger.kill());
	}

}
